import { render, staticRenderFns } from "./CaseBuildAssistant.vue?vue&type=template&id=5c0a01a5&scoped=true&"
import script from "./CaseBuildAssistant.vue?vue&type=script&lang=js&"
export * from "./CaseBuildAssistant.vue?vue&type=script&lang=js&"
import style0 from "./CaseBuildAssistant.vue?vue&type=style&index=0&id=5c0a01a5&scoped=true&lang=css&"
import style1 from "./CaseBuildAssistant.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a01a5",
  null
  
)

export default component.exports